module.exports = __webpack_public_path__ + "static/media/css.4dc3530b.png";